import axiosInstance from "app/axiosInstance";
import { ObjectsRequestDto } from "../entities/dtos/objects-request.dto";
import { types } from "@vilocnv/allsetra-core";

export const getObjects = async (payload: ObjectsRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get<types.IObject[]>(
      `/accounts/${accountId}/objects`
    );

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw new Error(e);
  }
};
